module.exports = __webpack_public_path__ + "img/sn2o.09dcf165.png";